import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Fiduciary } from '../../../core/data/clients/fiduciary.model';
import { emailValidator, requiredValidator } from '../../validators';
import { markAsTouched } from '../../utils';

@Component({
  selector: 'app-fiduciary-modal',
  templateUrl: './fiduciary-modal.component.html',
})
export class FiduciaryModalComponent {
  active = false;

  form = new FormGroup({
    id: new FormControl(),
    email: new FormControl('', [
      requiredValidator(),
      emailValidator(),
    ]),
    notifications: new FormGroup({
      standard: new FormControl(false),
      tax: new FormControl(false),
    }),
  });

  @Output() fiduciary = new EventEmitter<Fiduciary>();

  open(fiduciary?: Fiduciary) {
    this.active = true;
    this.form.reset();

    if (fiduciary) {
      this.form.setValue({
        ...fiduciary,
        ...{
          notifications: {
            standard: fiduciary.notifications.includes('standard'),
            tax: fiduciary.notifications.includes('tax'),
          }
        }
      });
    }
  }

  close() {
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.fiduciary.emit({
        ...this.form.value,
        ...{
          notifications: Object.keys(this.form.value.notifications)
            .filter((key) => this.form.value.notifications[key])
        }
      });
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fiduciaries/fiduciary-modal.component.ts